// extracted by mini-css-extract-plugin
export default {"page":"page-il8PO4","errorPage":"errorPage-Hf2Q2H","nofound":"nofound-k_2kuO","refresh":"refresh-pRljWg"};